// Logo Compra Agora: imagem oficial (public/logo-compra-agora.svg) com fallback em SVG.
// A sacola oficial (path extraído do arquivo da marca) é usada no overlay de carregamento.
import { useState } from 'react';

const VERMELHO = '#F4364C';
const AZUL = '#1CA4FF';

// Path da sacola extraído de public/logo-compra-agora.svg (arte oficial da marca)
const SACOLA_PATH = 'M21.0114 8.42018V8.28613C20.9775 8.25316 20.9775 8.25316 20.9775 8.21911C20.9775 8.18507 20.9446 8.18507 20.9446 8.15209L19.2769 5.04466C19.2209 4.94297 19.1387 4.85823 19.0389 4.79928C18.9392 4.74034 18.8254 4.70935 18.7097 4.70955H16.8575C16.5607 3.3744 15.8195 2.18049 14.7561 1.32444C13.6927 0.468398 12.3705 0.00127287 11.0072 0V0C9.64422 0.00175599 8.32247 0.469102 7.25952 1.32511C6.19656 2.18111 5.45574 3.37476 5.15902 4.70955H3.30258C3.18677 4.70924 3.07301 4.74018 2.97322 4.79913C2.87342 4.85809 2.79127 4.94289 2.73536 5.04466L1.06764 8.15209C1.06764 8.18507 1.03371 8.18507 1.03371 8.21911C1.03371 8.25316 1.03371 8.25316 1.00085 8.28613L0 22.3095V22.3403C0.00475518 23.5812 0.498494 24.7698 1.37346 25.6468C2.24843 26.5237 3.43358 27.0178 4.67026 27.0212H17.342C18.5787 27.0178 19.7638 26.5237 20.6388 25.6468C21.5138 24.7698 22.0075 23.5812 22.0122 22.3403V22.3063L21.0114 8.42018ZM11.0061 1.20319C12.0507 1.20517 13.0661 1.54904 13.8983 2.18262C14.7305 2.8162 15.3339 3.70489 15.617 4.71381H6.39311C6.6765 3.70463 7.28029 2.81578 8.11283 2.1822C8.94538 1.54861 9.96121 1.20488 11.0061 1.20319ZM17.1087 14.6457V15.1776C17.1048 16.7926 16.4642 18.3405 15.3268 19.4832C14.1893 20.6259 12.6475 21.2706 11.0379 21.2765H10.9743C9.36531 21.2706 7.82395 20.6264 6.6866 19.4843C5.54925 18.3423 4.90826 16.7953 4.90351 15.1808V14.6489C4.62484 14.5082 4.39021 14.2932 4.22542 14.0274C4.06063 13.7617 3.97206 13.4555 3.96946 13.1425C3.96946 12.6987 4.14516 12.273 4.45792 11.9592C4.77068 11.6454 5.19487 11.4691 5.63718 11.4691C6.07949 11.4691 6.50368 11.6454 6.81644 11.9592C7.1292 12.273 7.3049 12.6987 7.3049 13.1425C7.30137 13.4808 7.19809 13.8104 7.00809 14.0898C6.81809 14.3693 6.54987 14.586 6.23726 14.7127V15.1808C6.24229 16.4398 6.74302 17.6457 7.63033 18.5358C8.51764 19.426 9.71962 19.9281 10.9743 19.9329H11.0379C12.2926 19.9281 13.4946 19.426 14.3819 18.5358C15.2692 17.6457 15.77 16.4398 15.775 15.1808V14.7127C15.4619 14.5858 15.1933 14.3686 15.0033 14.0885C14.8132 13.8085 14.7102 13.4781 14.7073 13.1393C14.7073 12.6955 14.883 12.2699 15.1958 11.956C15.5086 11.6422 15.9328 11.4659 16.3751 11.4659C16.8174 11.4659 17.2416 11.6422 17.5543 11.956C17.8671 12.2699 18.0428 12.6955 18.0428 13.1393C18.0402 13.4523 17.9516 13.7585 17.7868 14.0243C17.622 14.29 17.3874 14.505 17.1087 14.6457ZM11.0072 7.81699H2.76823L3.70228 6.04891H18.3089L19.243 7.81699H11.0072Z';

interface SacolaProps {
  size?: number;
  animada?: boolean;
}

export function Sacola({ size = 48, animada = false }: SacolaProps) {
  // arte oficial: viewBox recortado só na sacola (22×27 do arquivo da marca)
  return (
    <svg viewBox="0 0 22.1 27.1" width={size} height={size} aria-hidden="true">
      {animada ? (
        <>
          {/* silhueta apagada + a mesma arte enchendo de cor (clip sobe via SMIL) */}
          <path d={SACOLA_PATH} fill={VERMELHO} opacity="0.15" />
          <defs>
            <clipPath id="sacola-enche-clip">
              <rect x="0" y="0" width="22.1" height="27.1">
                <animate attributeName="y" values="27.1;0;0" keyTimes="0;0.75;1" dur="1.6s" repeatCount="indefinite" />
              </rect>
            </clipPath>
          </defs>
          <path d={SACOLA_PATH} fill={VERMELHO} clipPath="url(#sacola-enche-clip)" />
        </>
      ) : (
        <path d={SACOLA_PATH} fill={VERMELHO} />
      )}
    </svg>
  );
}

interface LogoProps {
  size?: number;
  clara?: boolean; // fundo escuro (sidebar): wordmark branco
}

export function LogoCompraAgora({ size = 34, clara = false }: LogoProps) {
  return (
    <span className="inline-flex items-center gap-2">
      <Sacola size={size} />
      <span className="leading-none font-extrabold tracking-tight" style={{ fontSize: size * 0.42 }}>
        <span style={{ color: clara ? '#fff' : VERMELHO }}>COMPRA</span>{' '}
        <span style={{ color: clara ? '#7cc0f4' : AZUL }}>AGORA</span>
      </span>
    </span>
  );
}

// Logo oficial (public/logo-compra-agora.svg). Se o arquivo faltar, cai no wordmark SVG acima.
interface LogoImagemProps {
  height?: number;
  chip?: boolean; // fundo branco arredondado (para a sidebar navy)
  clara?: boolean; // fallback SVG em versão clara
}

export function LogoImagem({ height = 28, chip = false, clara = false }: LogoImagemProps) {
  const [falhou, setFalhou] = useState(false);
  if (falhou) return <LogoCompraAgora size={height + 4} clara={clara} />;
  const img = (
    <img
      src="/logo-compra-agora.svg"
      alt="Compra Agora"
      style={{ height, width: 'auto', display: 'block' }}
      onError={() => setFalhou(true)}
    />
  );
  if (!chip) return img;
  return <span className="inline-block bg-white rounded-lg px-2.5 py-1.5">{img}</span>;
}
